"use client";

import { useState } from "react";
import { devLabel } from "@/lib/dev-labels";

type Engine = "runway" | "did" | "slides";

export interface ScriptModeProps {
	onGenerate?: (script: string, engine: Engine) => void;
}

export function ScriptMode({ onGenerate }: ScriptModeProps) {
	const [script, setScript] = useState("");
	const [engine, setEngine] = useState<Engine>("did");

	const engines: { key: Engine; label: string }[] = [
		{ key: "runway", label: "자동 영상 (Runway)" },
		{ key: "did", label: "AI 아바타 (D-ID)" },
		{ key: "slides", label: "슬라이드 + TTS" },
	];

	return (
		<div {...devLabel("11-A4")}>
			<textarea
				value={script}
				onChange={(e) => setScript(e.target.value)}
				placeholder={`영상으로 만들 스크립트를 입력하세요...

예시:
오늘 들려드릴 충격적인 사실 — 10명 중 9명이 모르는 것이 바로 이것입니다.
실제로 200% 효과가 있다고 전문가들이 말합니다...`}
				style={{
					width: "100%",
					minHeight: 80,
					padding: 9,
					borderRadius: 6,
					background: "rgba(0,0,0,0.3)",
					border: "1px solid rgba(255,255,255,0.06)",
					color: "#dcdcdc",
					fontFamily: "inherit",
					fontSize: 12,
					resize: "vertical",
				}}
				aria-label="Script input"
			/>
			<div
				style={{
					display: "flex",
					alignItems: "center",
					justifyContent: "space-between",
					marginTop: 6,
					gap: 8,
					flexWrap: "wrap",
				}}
			>
				<div style={{ display: "flex", gap: 4 }}>
					{engines.map((e) => {
						const on = engine === e.key;
						return (
							<button
								key={e.key}
								type="button"
								onClick={() => setEngine(e.key)}
								style={{
									padding: "3px 8px",
									borderRadius: 4,
									background: on
										? "rgba(212,175,55,0.15)"
										: "rgba(255,255,255,0.04)",
									color: on ? "#d4af37" : "#dcdcdc",
									fontSize: 10,
									cursor: "pointer",
									border: "none",
								}}
							>
								{e.label}
							</button>
						);
					})}
				</div>
				<button
					type="button"
					onClick={() => onGenerate?.(script, engine)}
					style={{
						padding: "6px 16px",
						background: "#fff",
						color: "#0a0a0a",
						borderRadius: 5,
						fontWeight: 700,
						fontSize: 12,
						border: "none",
						cursor: "pointer",
					}}
				>
					생성 시작 (15코인)
				</button>
			</div>
		</div>
	);
}
